import { render } from "./NodeDetailsSimple.vue?vue&type=template&id=376a9673&ts=true"
import script from "./NodeDetailsSimple.vue?vue&type=script&lang=ts"
export * from "./NodeDetailsSimple.vue?vue&type=script&lang=ts"

import "./NodeDetailsSimple.vue?vue&type=style&index=0&id=376a9673&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__